// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3WipV","name":"ConsentHeader_name__1UQuz","birthday":"ConsentHeader_birthday__1hoVG","skeleton":"ConsentHeader_skeleton__2zzR-"};